module.exports = __webpack_public_path__ + "img/swam_t_logo.fffa19d0.png";